module.exports = __webpack_public_path__ + "static/media/sub-expired.e1a0fcb1.svg";